import type { StatusTone } from "@finora/config";

const TONE_CLASSES: Record<StatusTone, string> = {
  neutral: "bg-slate-100 text-slate-600 border-slate-200",
  info: "bg-blue-50 text-blue-700 border-blue-200",
  success: "bg-emerald-50 text-emerald-700 border-emerald-200",
  warning: "bg-amber-50 text-amber-700 border-amber-200",
  error: "bg-red-50 text-red-700 border-red-200",
};

const TONE_DOT_CLASSES: Record<StatusTone, string> = {
  neutral: "bg-slate-400",
  info: "bg-blue-500",
  success: "bg-emerald-500",
  warning: "bg-amber-500",
  error: "bg-red-500",
};

export interface StatusBadgeProps {
  label: string;
  tone: StatusTone;
  className?: string;
}

/**
 * Status se UVEK prikazuje kroz ovu komponentu (tekst + boja), nikad
 * samo boja bez teksta i nikad hardkodovan Tailwind class string
 * po ekranu - vidi zahtev "jasni statusi sa tekstom i bojom".
 */
export function StatusBadge({ label, tone, className }: StatusBadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-md border px-2 py-0.5 text-xs font-medium ${TONE_CLASSES[tone]} ${className ?? ""}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${TONE_DOT_CLASSES[tone]}`} />
      {label}
    </span>
  );
}
